import { FC, useState } from 'react'
import { Icons } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'
import { APopoverButton } from 'views/components/Analytics/APopoverButton'
import { PopoverContainer } from 'views/styled/common'
import BidRoutes from 'views/pages/Bid/routes'
import { Bid, BidStatus, USBid } from 'modules/domain/bid/types'
import { generatePath } from 'react-router-dom'
import { WarehouseMovementsModal } from 'views/components/WarehouseMovementsModal/WarehouseMovementsModal'
import { AddSampleRequestModal } from 'views/components/Sample/SampleRequest/AddSampleRequestModal'
import { useUserSamplesContext } from '../../UserSamplesContext'

type Props = {
  bid: Bid | USBid
  setPopoverVisible: (arg: boolean) => void
  refetch: () => void
}

export const BidPopoverContent: FC<Props> = ({ bid, setPopoverVisible, refetch }) => {
  const { t } = useTranslation('bid')
  const [warehouseModal, setWarehouseModal] = useState(false)
  const [addSampleRequest, setAddSampleRequest] = useState(false)

  const { refetch: refetchSamples } = useUserSamplesContext()

  const refetchForSamples = () => {
    refetchSamples(true)
    refetch()
  }

  return (
    <PopoverContainer
      width={190}
      onClick={(e) => {
        e.stopPropagation()
        setPopoverVisible(false)
      }}
    >
      <APopoverButton
        id="bidActionBid"
        text={t('goToBid')}
        to={generatePath(bid.status === BidStatus.potential ? BidRoutes.PotentialBidDetail : BidRoutes.Details, {
          id: bid.id,
        })}
        Icon={<Icons.IconOpen />}
        analyticsPayload={{ id: bid.id }}
      />
      <APopoverButton
        id="warehouseMovements"
        Icon={<Icons.IconGarageMove />}
        onClick={() => setWarehouseModal(true)}
        text={t('sendToWarehouse')}
      />
      <APopoverButton
        id="createSampleRequest"
        Icon={<Icons.IconSampling />}
        onClick={() => setAddSampleRequest(true)}
        text={t('createSampleRequest')}
      />
      {warehouseModal && (
        <WarehouseMovementsModal bidId={bid.id} onSuccess={refetch} onClose={() => setWarehouseModal(false)} />
      )}
      {addSampleRequest && (
        <AddSampleRequestModal bid={bid} refetch={refetchForSamples} onClose={() => setAddSampleRequest(false)} />
      )}
    </PopoverContainer>
  )
}
